import { render, staticRenderFns } from "./RevitaBlu.vue?vue&type=template&id=0b70827a&scoped=true&"
import script from "./RevitaBlu.vue?vue&type=script&lang=js&"
export * from "./RevitaBlu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70827a",
  null
  
)

export default component.exports